"use client"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material"
import { WarningAmberRounded as WarningIcon } from "@mui/icons-material"

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Yes, delete it!",
  cancelText = "Cancel",
  confirmButtonColor = "primary",
  cancelButtonColor = "error",
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              border: "3px solid #ffb74d", // Light orange border
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "transparent",
            }}
          >
            <WarningIcon sx={{ fontSize: 50, color: "#ffb74d" }} /> {/* Orange exclamation icon */}
          </Box>
        </Box>
        <DialogTitle sx={{ p: 0, mb: 1 }}>
          <Typography variant="h5" component="h2" sx={{ fontWeight: "bold", color: "#333" }}>
            {title}
          </Typography>
        </DialogTitle>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3, px: 3, gap: 2 }}>
        <Button variant="contained" color={confirmButtonColor} onClick={onConfirm} sx={{ minWidth: 120 }}>
          {confirmText}
        </Button>
        <Button variant="contained" color={cancelButtonColor} onClick={onClose} sx={{ minWidth: 120 }}>
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
